<!-- Font Awesome -->
<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css"
/>

<!-- HEADER -->
<header
  class="w-full bg-white shadow-md fixed top-0 left-0 z-50 border-b border-gray-100"
>
  <div class="max-w-7xl mx-auto px-4 sm:px-6">
    <div class="flex items-center justify-between h-16">
      <!-- Logo -->
      <a href="home-landing" class="flex-shrink-0">
        <img
          src="assets/TrailFusion/logo.png"
          alt="TrailFusion Logo"
          class="h-8 w-auto"
        />
      </a>

      <!-- Desktop Nav -->
      <nav
        class="hidden md:flex items-center space-x-8 mx-auto text-gray-700 font-medium"
      >
        <a
          href="/about-us"
          class="hover:text-teal-600 transition-colors duration-300"
          >About Us</a
        >
        <a
          href="/explore-programs"
          class="hover:text-teal-600 transition-colors duration-300"
          >Explore Programs</a
        >
        <a
          href="/our-clients"
          class="hover:text-teal-600 transition-colors duration-300"
          >Our Clients</a
        >

        <!-- Onboarding Form Dropdown (Desktop) -->
        <div class="relative group">
          <button
            class="hover:text-teal-600 transition-colors duration-300 flex items-center space-x-1 focus:outline-none focus:text-teal-700 text-[14px] font-medium"
            aria-haspopup="true"
          >
            <span>Onboarding Form</span>
            <i
              class="fa fa-chevron-down text-xs transition-transform duration-200 group-hover:rotate-180"
            ></i>
          </button>

          <div
            class="absolute left-0 mt-2 w-48 bg-white border border-gray-200 shadow-lg rounded-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 transform group-hover:translate-y-0 translate-y-1"
          >
            <a
              href="/register-your-program"
              class="block px-2 py-2 text-gray-700 hover:bg-gray-50 hover:text-teal-600 transition-colors text-[14px]"
            >
              Organization Onboarding
            </a>
            <a
              href="/member-onboarding"
              class="block px-2 py-2 text-gray-700 hover:bg-gray-50 hover:text-teal-600 transition-colors text-[14px]"
            >
              Member Onboarding
            </a>
          </div>
        </div>

        <a
          href="/contactus"
          class="hover:text-teal-600 transition-colors duration-300"
          >Contact Us</a
        >
      </nav>

      <!-- Auth Links -->
      <div class="hidden md:flex items-center space-x-1 ml-auto">
        <a
          href="/sign-in"
          class="text-gray-600 hover:text-teal-600 transition-colors duration-300 py-1"
          >Sign In</a
        >
        <span class="text-gray-600">|</span>
        <a
          href="/sign-up"
          class="text-gray-600 hover:text-teal-600 transition-colors duration-300 py-1"
          >Sign Up</a
        >
      </div>

      <!-- Mobile Menu Button -->
      <div class="md:hidden ml-auto">
        <button
          id="mobile-menu-button"
          (click)="toggleMenu()"
          class="p-2 text-gray-600 hover:text-teal-600 hover:bg-gray-100 rounded-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-teal-500"
          [attr.aria-expanded]="menuOpen"
          aria-label="Toggle navigation menu"
        >
          <!-- Menu Icon -->
          <svg
            id="menu-icon"
            class="h-6 w-6"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            viewBox="0 0 24 24"
            stroke-linecap="round"
            stroke-linejoin="round"
            [class.hidden]="menuOpen"
          >
            <path d="M4 6h16M4 12h16M4 18h16" />
          </svg>

          <!-- Close Icon -->
          <svg
            id="close-icon"
            class="h-6 w-6"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            viewBox="0 0 24 24"
            stroke-linecap="round"
            stroke-linejoin="round"
            [class.hidden]="!menuOpen"
          >
            <path d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Mobile Nav -->
  <div
    id="mobile-menu"
    class="md:hidden bg-white shadow-lg border-t border-gray-100"
    [class.hidden]="!menuOpen"
  >
    <div class="px-4 py-4 space-y-1">
      <a
        href="/about-us"
        class="block py-3 px-4 text-gray-700 hover:text-teal-600 hover:bg-gray-50 rounded-md transition-colors"
        >About Us</a
      >
      <a
        href="/explore-programs"
        class="block py-3 px-4 text-gray-700 hover:text-teal-600 hover:bg-gray-50 rounded-md transition-colors"
        >Explore Programs</a
      >
      <a
        href="/our-clients"
        class="block py-3 px-4 text-gray-700 hover:text-teal-600 hover:bg-gray-50 rounded-md transition-colors"
        >Our Clients</a
      >

      <!-- Mobile Onboarding Dropdown -->
      <div class="block py-2 px-4">
        <button
          id="mobile-dropdown-button"
          (click)="toggleMobileDropdown()"
          class="flex items-center justify-between w-full text-gray-700 font-medium text-[14px] focus:outline-none"
          [attr.aria-expanded]="mobileDropdownOpen"
        >
          <span>Onboarding Form</span>
          <i
            class="fa"
            [ngClass]="mobileDropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down'"
          ></i>
        </button>
        <div
          id="mobile-dropdown"
          class="mt-1 space-y-1 pl-4"
          [class.hidden]="!mobileDropdownOpen"
        >
          <a
            href="/register-your-program"
            class="block py-2 text-gray-600 hover:text-teal-600 text-[14px]"
          >
            Organization Onboarding
          </a>
          <a
            href="/member-onboarding"
            class="block py-2 text-gray-600 hover:text-teal-600 text-[14px]"
          >
            Member Onboarding
          </a>
        </div>
      </div>

      <a
        href="/contactus"
        class="block py-3 px-4 text-gray-700 hover:text-teal-600 hover:bg-gray-50 rounded-md transition-colors"
        >Contact Us</a
      >

      <div class="border-t border-gray-200 pt-4 mt-2 flex space-x-3">
        <a
          href="/sign-in"
          class="flex-1 text-center py-2 text-gray-600 hover:text-teal-600 rounded-md hover:bg-gray-50 transition-colors"
          >Sign In</a
        >
        <a
          href="/sign-up"
          class="flex-1 text-center py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors"
          >Sign Up</a
        >
      </div>
    </div>
  </div>
</header>

<!-- 🧩 Add this below header (to prevent content overlap) -->
<main class="pt-16">
  <!-- Your page content -->
</main>
